const moment = require('moment');

module.exports = {
    inlineDatesAdverb: {
        calendar: {
            sameDay: '[at] h:mmA',
            lastDay: '[on] MMMM D',
            nextDay: '[on] MMMM D',
            lastWeek: '[on] MMMM D',
            nextWeek: '[on] MMMM D',
            sameElse: function(now) {
                return '[on] MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
            },
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
    },
};



// WEBPACK FOOTER //
// ./assets/js/messageCenter/momentLocales.es.js